import { useRef, useState } from 'react';
import Slider, { Settings } from 'react-slick';

/**
 * Carousel Props
 */
type CarouselProps = Settings & {
  showArrows?: boolean;
  count?: number;
};

/**
 * Use Carousel
 */
const useCarousel = (_: CarouselProps) => {
  const carouselRef = useRef<Slider>(null);

  const [selectedIndex, setSelectedIndex] = useState(0);

  const checkIsArrowHidden = (key: string, childrenCount: number) =>
    (key === 'prev' && selectedIndex === 0) ||
    (key === 'next' && childrenCount === selectedIndex + 1);

  const onClickPrevSlide = () => {
    //@ts-ignore
    carouselRef.current.slickPrev();
  };

  const onClickNextSlide = () => {
    //@ts-ignore
    carouselRef.current.slickNext();
  };

  return {
    selectedIndex,
    carouselRef,
    setSelectedIndex,
    checkIsArrowHidden,
    onClickPrevSlide,
    onClickNextSlide
  };
};

export { useCarousel };
export type { CarouselProps };
